<div id="{{ elementId }}" class="modal fade" tabindex="-1">
  <div
    class="modal-dialog custom-dialog"
    [class.modal-lg]="modalLg"
    [class.modal-dialog-centered]="centered"
    [ngStyle]="{ 'max-width': styles['modalContentWidth'] }"
  >
    <div class="modal-content" [class.pb-0]="noPaddingBottom">
      <div class="modal-header custom-modal-header py-2 px-2">
        <h4 class="modal-title ">
          {{ headerTitle }}
        </h4>
        <button class="close" type="button" data-dismiss="modal" #close>
          <span><img src="assets/images/modalClose.png"/></span>
        </button>
      </div>
      <div
        class="modal-body px-2 py-0"
        [ngStyle]="{ height: styles['modalBodyHeight'] }"
      >
        <ng-content select=".content"></ng-content>
      </div>
      <ng-content select=".modal-footer"></ng-content>
    </div>
  </div>
</div>
